import AutocompleteObjectV2 from "../../component/AutocompleteObjectV2";
import {columnNamesTypeTableCollapse} from "@oceantech/oceantech-ui";
import {useEffect} from "react";
import {searchDepartments} from "../services/reportAssignment";
import {localStorageItem} from "../../utils/LocalStorage";
import {KEY_LOCALSTORAGE} from "../../auth/core/_consts";

export const useColumns = (props: any) => {
  const {handleChangeRowInput, handleGetListDepartment, listDepartment} = props;
  const {org = ""} = localStorageItem.get(KEY_LOCALSTORAGE.ACCESS_TOKEN_DECODE)

  useEffect(() => {
    handleGetListDepartment?.()
  }, [handleGetListDepartment]);

  const columns: columnNamesTypeTableCollapse[] = [
  {
    name: "STT",
    field: "stt",
    headerStyle: {
      minWidth: 50,
      maxWidth: 50,
    },
    cellStyle: {
      textAlign: "center",
    },
    render: (row: any, index: number, stt: number | undefined) => stt,
  },
  {
    name: "Tên",
    field: "criteriaName",
    headerStyle: {
      minWidth: 500,
    },
    cellStyle: {
      textAlign: "left",
    },
    render: (row: any) => row.criteriaName || '',
  },
  {
    name: "Phòng ban",
    field: "department",
    headerStyle: {
      minWidth: 200,
    },
    cellStyle: {
      textAlign: "left",
    },
    render: (row: any, index: number) => {
      console.log("row?.assign", row?.assign)
      return (
        <AutocompleteObjectV2
          searchFunction={searchDepartments}
          searchObject={{
            pageIndex: 1,
            pageSize: 9999,
            level: 2,
            orgId: org,
          }}
          options={listDepartment}
          name="assign"
          value={row?.assign ?? null}
          onChange={(options: any) => handleChangeRowInput(index, options, "result")}
          className="autocomplete-custom-renderform pl-5 radius spaces min-w-200 h-29"
        />
      )
    },
  },
];
  return columns
}